import { WEB_VOICE_OPENER_EN } from './scripts'

/**
 * Matt 2026-10-29 2:07 PM PT, Counsel conditions 2:08 PM PT (web voice only):
 * Sarah's first spoken words are "Hey, this is Sarah. How can I help?" with no
 * spoken recording notice. The notice is on screen before the click (launcher
 * caption) and during the session (Recorded indicator). The phone greeting is
 * separate and unchanged.
 */
export const SARAH_WEB_SPOKEN_RECORDING_NOTICE = false

export const WEB_VOICE_OPENER_SHORT_EN = 'Hey, this is Sarah. How can I help?'

/**
 * Recording notice wording, used as the panel header tooltip. Matt 2026-11-01:
 * nothing shows under the closed launcher; the panel header shows
 * "Recorded · Privacy" (Privacy links to /privacy) the moment the chat opens.
 */
export const SARAH_WEB_LAUNCHER_NOTICE_EN = 'Chats are recorded'
export const SARAH_WEB_NOTICE_SEPARATOR = ' · '
export const SARAH_WEB_PRIVACY_LABEL_EN = 'Privacy'
export const SARAH_WEB_PRIVACY_HREF = '/privacy'

/** In-session indicator in the compact voice view. */
export const SARAH_WEB_RECORDED_LABEL_EN = 'Recorded'

export function webVoiceOpener(spokenNotice: boolean = SARAH_WEB_SPOKEN_RECORDING_NOTICE): string {
  return spokenNotice ? WEB_VOICE_OPENER_EN : WEB_VOICE_OPENER_SHORT_EN
}

/**
 * Bump when the launcher notice wording changes; stored as wording_version.
 * v4 (Matt 2026-11-01): no caption under the closed launcher. The notice is the
 * panel header "Recorded · Privacy", shown as the chat opens on the click.
 */
export const SARAH_WEB_LAUNCHER_NOTICE_VERSION = 'sarah-web-launcher-notice-v4-2026-11-01'
